import { StoreApi } from 'zustand';

import { INITIAL_SELECTED_ITEMS_STATE, SelectedItemsStore } from './types';

type ZustandSet = StoreApi<SelectedItemsStore>['setState'];

type SelectedItemKey =
  | 'inboxItems'
  | 'sentItems'
  | 'draftItems'
  | 'spamItems'
  | 'trashItems'
  | 'allMailItems'
  | 'labelsItems';

const handleSetSelectedItems =
  (key: SelectedItemKey) => (set: ZustandSet, items: string[]) => {
    set((state) => ({
      selectedItems: {
        ...state.selectedItems,
        [key]: items,
      },
    }));
  };

export const handleSetInboxItems = handleSetSelectedItems('inboxItems');
export const handleSetSentItems = handleSetSelectedItems('sentItems');
export const handleSetDraftItems = handleSetSelectedItems('draftItems');
export const handleSetSpamItems = handleSetSelectedItems('spamItems');
export const handleSetTrashItems = handleSetSelectedItems('trashItems');
export const handleSetAllMailItems = handleSetSelectedItems('allMailItems');
export const handleSetLabelsItems = handleSetSelectedItems('labelsItems');

export const clearSelection = (set: ZustandSet) => {
  set(() => {
    return {
      selectedItems: {
        inboxItems: [],
        sentItems: [],
        draftItems: [],
        spamItems: [],
        trashItems: [],
        allMailItems: [],
        labelsItems: [],
      },
    };
  });
};

export const handleResetState = (set: ZustandSet) => {
  set(INITIAL_SELECTED_ITEMS_STATE);
};
